import { client, clientFree } from "./axios";

const JSON_HEADERS = {
  "Content-Type": "application/json",
  Accept: "application/json",
};

interface authApi {
  signIn: (email: string, password: string) => Promise<void>;
  signUp: (
    email: string,
    password: string,
    name: string,
    birthDate: string
  ) => Promise<void>;
  refreshToken: () => Promise<void>;
  signOut: () => Promise<any>;
  sendResetCode: (email: string) => void;
  resetPassword: (email: string, code: string, password: string) => void;
  deleteAccount: () => void;
}

export const authApi: authApi = {
  signIn: async (email: string, password: string) => {
    const params = {
      email: email,
      password: password,
    };
    const response = await clientFree.post("/v2/users/signIn?isCookie=true", params, {
      headers: JSON_HEADERS,
    });
    return response.data;
  },

  signUp: async (
    email: string,
    password: string,
    name: string,
    birthDate: string
  ) => {
    const params = {
      email: email,
      language: "en",
      password: password,
      payload: {
        name: name,
        birthday: birthDate
      }
    };
    const response = await clientFree.post("/v2/users/signUp?isCookie=true", params, {
      headers: JSON_HEADERS,
    });
    console.log(response.data);
    return response.data;
  },

  refreshToken: async ():Promise<void> => {
  await clientFree.post(
      "/refreshToken?isCookie=true",
      {},
      {
        headers: JSON_HEADERS,
      }
    );
  },

  signOut: async () => {
    const response = await client.post(
      "/exit?isCookie=true",
      {
        headers: JSON_HEADERS,
      }
    );

    return response.data;
  },

  sendResetCode: async (email: string) =>
    await clientFree.post(`/users/password/resetCode?email=${email}&language=ru`),

  resetPassword: async (email: string, code: string, password: string) =>
    await clientFree.post(
      "/users/password/reset",
      {
        email: email,
        code: code,
        password: password,
      },
      {
        headers: JSON_HEADERS,
      }
    ),
    deleteAccount: async () => await client.delete("/deleteUser"),
};
